import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as policy from '../policy'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: policy.RESOURCE.payload.dimension.partialId,
      partialId: policy.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'The policy document(s). Files are stored in the shared knowledge base, scoped to this record.',
    isOptional: true,
    name: 'Documents',
    partialId: PartialId.Standard.create('documents'),
    type: { isFile: true },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
